import type { GigsafePermission, GigsafeRole, GigsafeUser } from 'src/interfaces/gigsafeUser'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getGigsafeUsers = (state: State): GigsafeUser[] => {
  return state.gigsafeUser.users
}

export const getGigsafeUsersTotal = (state: State): number => {
  return state.gigsafeUser.usersTotal
}

export const getGigsafeUsersLoading = (state: State): boolean => {
  return state.gigsafeUser.usersLoading
}

export const getGigsafeUsersError = (state: State): string | null => {
  return state.gigsafeUser.usersError
}

export const getGigsafeUserInviting = (state: State): boolean => {
  return state.gigsafeUser.inviting
}

export const getGigsafeRoles = (state: State): GigsafeRole[] => {
  return state.gigsafeUser.roles
}

export const getGigsafeRolesLoading = (state: State): boolean => {
  return state.gigsafeUser.rolesLoading
}

export const getGigsafeRolesError = (state: State): string | null => {
  return state.gigsafeUser.rolesError
}

export const getGigsafePermissions = (state: State): GigsafePermission[] => {
  return state.gigsafeUser.permissions
}

export const getGigsafePermissionsLoading = (state: State): boolean => {
  return state.gigsafeUser.permissionsLoading
}

export const getGigsafeRoleSaving = (state: State): boolean => {
  return state.gigsafeUser.savingRole
}
